export default {
  'Puer':           'mars',
  'Amissio':        'venus',
  'Albus':          'mercury',
  'Populus':        'moon',
  'Fortuna Major':  'sun',
  'Conjunctio':     'mercury',
  'Puella':         'venus',
  'Rubeus':         'mars',
  'Acquisitio':     'jupiter',
  'Carcer':         'saturn',
  'Tristitia':      'saturn',
  'Laetitia':       'jupiter',
  'Cauda Draconis': 'south-node',
  'Caput Draconis': 'north-node',
  'Fortuna Minor':  'sun',
  'Via':            'moon',
}
